import { render, staticRenderFns } from "./ForbiddenSvg.vue?vue&type=template&id=7484b737&"
import script from "./ForbiddenSvg.vue?vue&type=script&lang=ts&"
export * from "./ForbiddenSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports